import {
  CannedMessage,
  CannedMessageQuery
} from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';

export const getCannedMessages = createAction(
  '[CannedMessages] Get Canned Messages',
  props<{ query?: CannedMessageQuery }>()
);

export const getCannedMessagesSuccess = createAction(
  '[CannedMessages] Get Canned Messages Success',
  props<{ cannedMessages: CannedMessage[] }>()
);

export const getCannedMessagesFailure = createAction(
  '[CannedMessages] Get Canned Messages Failure',
  props<{ error: any }>()
);

export const addCannedMessage = createAction(
  '[CannedMessages] Add Canned Message',
  props<{ cannedMessage: CannedMessage }>()
);

export const addCannedMessageSuccess = createAction(
  '[CannedMessages] Add Canned Message Success',
  props<{ cannedMessage: CannedMessage }>()
);

export const addCannedMessageFailure = createAction(
  '[CannedMessages] Add Canned Message Failure',
  props<{ error: any }>()
);

export const updateCannedMessage = createAction(
  '[CannedMessages] Update Canned Message',
  props<{ cannedMessage: CannedMessage }>()
);

export const updateCannedMessageSuccess = createAction(
  '[CannedMessages] Update Canned Message Success',
  props<{ cannedMessage: CannedMessage }>()
);

export const updateCannedMessageFailure = createAction(
  '[CannedMessages] Update Canned Message Failure',
  props<{ error: any }>()
);

export const deleteCannedMessage = createAction(
  '[CannedMessages] Delete Canned Message',
  props<{ id: string }>()
);

export const deleteCannedMessageSuccess = createAction(
  '[CannedMessages] Delete Canned Message Success',
  props<{ id: string }>()
);

export const deleteCannedMessageFailure = createAction(
  '[CannedMessages] Delete Canned Message Failure',
  props<{ error: any }>()
);

export const selectCannedMessage = createAction(
  '[CannedMessages] Select Canned Message',
  props<{ id: string }>()
);
